<template>
  <AppWithLoading :fetch="fetch">
    <div v-if="quota">
      <slot v-if="!quota.sms" name="exceeded" />
      <slot v-else name="normal" />
    </div>
  </AppWithLoading>
</template>

<script>
import useAccount from '@/compositions/accounting/useAccount';
import { paymentTabs, settingsTabs } from '@/enums';
import AppWithLoading from '@/components/AppWithLoading';

export default {
  name: 'InterviewsQuotaCandidateSmsExceeded',
  components: { AppWithLoading },
  setup(_, { root: { $router } }) {
    const { quota, fetch } = useAccount();
    function changePlan() {
      $router.push({ name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } });
    }
    return {
      quota,
      fetch,
      changePlan,
    };
  },
};
</script>

<style scoped>

</style>
